module.exports = __webpack_public_path__ + "img/equipement-solaire.b9eef49c.svg";